import { type FormEvent, useState } from 'react';
import { Box, Button, Stack, TextField, Typography } from '@mui/material';

interface PasscodeGateProps {
  errorMessage: string | null;
  isSubmitting: boolean;
  isResending: boolean;
  hasResent: boolean;
  resendMessage: string | null;
  onSubmit: (passcode: string) => void;
  onResend: () => void;
}

export function PasscodeGate({
  errorMessage,
  isSubmitting,
  isResending,
  hasResent,
  resendMessage,
  onResend,
  onSubmit
}: PasscodeGateProps) {
  const [passcode, setPasscode] = useState('');

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSubmit(passcode);
  };

  return (
    <Stack minHeight="100vh" alignItems="center" justifyContent="center" px={2}>
      <Box component="form" onSubmit={handleSubmit} width="100%" maxWidth={360}>
        <Stack spacing={2}>
          <Stack spacing={0.5}>
            <Typography variant="h5">Enter passcode</Typography>
            <Typography color="text.secondary">
              Enter the eight-character passcode from your referral email.
            </Typography>
          </Stack>
          <TextField
            autoComplete="one-time-code"
            autoFocus
            error={Boolean(errorMessage)}
            fullWidth
            helperText={errorMessage ?? ' '}
            inputProps={{ maxLength: 8 }}
            label="Passcode"
            onChange={(event) => setPasscode(event.target.value)}
            required
            value={passcode}
          />
          <Button
            disabled={!passcode}
            fullWidth
            loading={isSubmitting}
            type="submit"
            variant="contained"
            className="ph-no-capture"
          >
            Continue
          </Button>
          <Button
            disabled={isResending || hasResent}
            fullWidth
            loading={isResending}
            onClick={onResend}
            type="button"
            variant="text"
          >
            Re-send passcode email
          </Button>
          {resendMessage && (
            <Typography align="center" color="text.secondary" variant="body2">
              {resendMessage}
            </Typography>
          )}
        </Stack>
      </Box>
    </Stack>
  );
}
